import React from 'react';
import styles from './serviceCard.module.scss';
import Button from '@mui/material/Button';

export interface ServiceCardProps {
  logo: string;
  title: string;
  description: string;
  buttonText: string;
  onClick?: any;
  disabled?: boolean;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ 
  logo, 
  title, 
  description, 
  buttonText, 
  onClick,
  disabled = false
}) => {
  return (
    <div className={`${styles.serviceCard} ${disabled ? styles.disabled : ''}`}>
      <div className={styles.logoContainer}>
        <img src={logo} alt={title} className={styles.logo} />
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
      <Button 
        variant="outlined" 
        className={styles.actionButton}
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default ServiceCard;
